import { GlobalState } from '../../../../1stlog-ui/src/components/OrderDetails/helpers'

export type Status =
  | 'waiting'
  | 'inprogress'
  | 'success'
  | 'error'
  | 'cancelled'
  | 'unknown'

export function getIndependendStatus(
  globalState: GlobalState,
  isPickup: boolean,
): Status {
  if (!globalState) return 'unknown'
  if (globalState.isCancelled) return 'cancelled'
  if (!globalState.isPickedUp && !globalState.isDelivered) return 'waiting'
  if (isPickup) {
    if (globalState.hasPickupIssues) return 'error'
    if (globalState.isPickedUp) return 'success'
    return 'inprogress'
  } else {
    if (globalState.hasDeliveryIssue) return 'error'
    if (globalState.isDelivered) return 'success'
    return 'inprogress'
  }
}

export const colors = {
  waiting: 'gray',
  inprogress: 'blue',
  success: 'green',
  error: 'red',
  cancelled: 'red',
  unknown: 'lightgray',
}
